export default __webpack_public_path__ + "static/media/modal-info.30a971c8.svg";